import { createContextSelectorHooks } from "core/utils/contextUtils"
import { AppInitContext, AppInitContextProps } from "../AppInitContext"
import { AppInitState } from "../types"

export const {
  useSelector: useAppInitSelector,
  useSelectorWithEquality: useAppInitSelectorWithEquality
} = createContextSelectorHooks<AppInitContextProps, AppInitState>(
  AppInitContext,
  'AppInit'
)

export const useIsAppInitialized = () => {
  return useAppInitSelector(state => state.isInitialized)
}

export const useIsAppLoading = () => {
  return useAppInitSelector(state => state.isLoading)
}

export const useAppError = () => {
  return useAppInitSelector(state => state.error)
}

export const useCurrentPlateforme = () => {
  return useAppInitSelector(state => state.currentPlateforme)
}

export const usePlateformes = () => {
  return useAppInitSelector(state => state.plateformes)
}

export const usePlateformeTheme = () => {
  return useAppInitSelector(state => state.theme)
}
